import React, { useEffect, useState, useMemo } from "react";
import isEmpty from "lodash/isEmpty";
import { Button, FormControl, InputGroup, Modal } from "react-bootstrap";
import { updateQueryString } from "./lib/utils";

const CategorySearchBox = ({ keyword, onKeywordChange }) => {
    return <div>
        <InputGroup className="mb-3">
            <FormControl
                placeholder="カテゴリを検索"
                aria-label="カテゴリを検索"
                value={keyword} onChange={e => onKeywordChange(e.target.value)}
            />
            <Button variant="outline-secondary" onClick={() => onKeywordChange('')}><i className="fa fa-times" /></Button>
        </InputGroup>
    </div>
};

const CategoryCandidates = ({ keyword, onCategorySelect, apiPath }) => {
    const [candidates, setCandidates] = useState([]);
    useEffect(() => {
        fetch(`${apiPath}?keyword=${keyword}`)
            .then(e => e.json())
            .then(setCandidates);
    }, [keyword]);
    const genOnClick = category_id => e => {
        e.preventDefault();
        onCategorySelect(category_id);
        return false;
    };
    return <ul>
        {
            candidates.map(arr =>
                <li key={`cat-candidate-${arr[arr.length - 1].category_id}`}>
                    <a href='#'
                        onClick={genOnClick(arr[arr.length - 1].category_id)}>{arr.map(({ name }) => name).join(' > ')}</a></li>)
        }
    </ul>
};

const CategoryTree = ({ categoryHash, categoryRepo, selected, onSelect }) => {
    const siblings = (category) =>
        categoryRepo.filter(r => category.parent === r.parent)
            .sort((a, b) => a.id - b.id);

    const getCategories = (category_id) => {
        const tree = [];
        let category = categoryHash[category_id];
        while (category !== undefined) {
            tree.unshift(category);
            category = categoryHash[category.parent];
        }
        const categories = tree.map((category) => siblings(category));
        const children = siblings({ parent: category_id });
        if (children.length) {
            categories.push(children);
        }
        return { tree, categories };
    };

    const { tree, categories } = getCategories(selected);

    return <ul className='categories-container mt-2'>
        {
            categories.map((arr, i) => <li key={`category-group-${i}`} className='categories'>
                <ul>
                    {
                        arr.map((category) => {
                            const classes = ['category'];
                            if (tree.indexOf(category) > -1) {
                                classes.push('active');
                            }
                            if (category.id === selected) {
                                classes.push('selected');
                            }
                            return <li key={`category-${category.id}`} className={classes.join(' ')}
                                onClick={() => onSelect(category.id)}>
                                {category.name}</li>;
                        })
                    }
                </ul>
            </li>)
        }
    </ul>
};

const SearchCategory = ({ url, value, categories: categoriesCSV, apiPath }) => {
    const [show, setShow] = useState(false);
    const [selectedLabel, setSelectedLabel] = useState(null);

    const { categoryHash, categoryRepo } = useMemo(() => {
        const hash = {};
        if (!categoriesCSV) return { categoryHash: hash, categoryRepo: [] };
        const repo = categoriesCSV.split(',').map((s) => {
            const [parent, id, name] = s.split(':');
            return hash[id] = { parent, id, name };
        });
        return { categoryHash: hash, categoryRepo: repo };
    }, [categoriesCSV]);

    const defaultCategoryId = useMemo(() => {
        return categoryRepo.filter(r => !r.parent).sort((a, b) => a.id - b.id)[0]?.id;
    }, [categoryRepo]);

    const [selected, setSelected] = useState(value || defaultCategoryId);
    const [keyword, setKeyword] = useState('');

    // valueがあるがcategoryHashにない場合、APIから取得
    useEffect(() => {
        if (value && !categoryHash[value]) {
            fetch(`${apiPath}/${value}`)
                .then(e => e.json())
                .then(data => {
                    if (data?.name) setSelectedLabel(data.name);
                })
                .catch(() => {});
        }
    }, [value, categoryHash, apiPath]);

    const selectedCategory = value ? categoryHash[value] : null;
    const label = selectedCategory ? selectedCategory.name : (selectedLabel || '未選択');

    const handleApply = () => {
        setShow(false);
        updateQueryString({ service_category_id: selected });
    };

    const handleClear = () => {
        setShow(false);
        updateQueryString({ service_category_id: '' });
    };

    const handleClose = () => {
        setShow(false);
        setSelected(value || defaultCategoryId);
        setKeyword('');
    };

    const pendingCategory = categoryHash[selected];

    return <>
        <InputGroup className="align-items-center">
            <InputGroup.Text>カテゴリー</InputGroup.Text>
            <Button variant={value ? "primary" : "outline-secondary"} onClick={() => setShow(true)}
                style={{ minWidth: 80, textAlign: 'left' }}>
                {label}
            </Button>
            {value && <Button variant="outline-secondary" onClick={handleClear}><i className="fa fa-times" /></Button>}
        </InputGroup>

        <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>カテゴリーで絞り込み</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pendingCategory &&
                    <div className="mb-2">
                        <strong>選択中: </strong>{pendingCategory.name} ({pendingCategory.id})
                    </div>
                }
                <CategorySearchBox keyword={keyword} onKeywordChange={setKeyword} />
                {
                    !isEmpty(keyword) &&
                    <CategoryCandidates keyword={keyword} onCategorySelect={(id) => {
                        setShow(false);
                        updateQueryString({ service_category_id: id });
                    }} apiPath={apiPath} />
                }
                {
                    isEmpty(keyword) &&
                    <CategoryTree categoryHash={categoryHash} categoryRepo={categoryRepo}
                        selected={selected} onSelect={setSelected} />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClear}>解除</Button>
                <Button variant="secondary" onClick={handleClose}>キャンセル</Button>
                <Button variant="primary" onClick={handleApply}>適用</Button>
            </Modal.Footer>
        </Modal>
    </>;
};

export default SearchCategory;
